import { Component, OnInit } from '@angular/core';
import Utils from '../../util';

@Component({
  selector: 'app-logout',
  styleUrls: ['./logout.component.scss'],
  templateUrl: './logout.component.html'
})
export class LogoutComponent implements OnInit {
  ngOnInit() {
    window.location.href = Utils.getLogoutUrl();
  }
}
